// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OPyxSSwgH90qsft97wLw{align-items:flex-start;gap:12px;padding-bottom:8px;display:flex}.YTX89g_TpUTsjdszYaX6{align-items:center;padding-right:2px}.nGaU_AKcWIQTm7M9z2Ii{gap:4px;width:100%;max-width:188px;min-height:32px;padding-top:8px;display:flex}.XLhDffnrqOk1xDuJsGD5{flex-direction:column;width:100%;min-width:0;min-height:32px;padding-top:8px;display:flex}.YTX89g_TpUTsjdszYaX6 .XLhDffnrqOk1xDuJsGD5,.CjdSi1oino385ZVbJOXP .XLhDffnrqOk1xDuJsGD5{padding-top:0}.mSFfNKx97ZErWDrUFZsP{padding:8px}.Eif3jqOb860fK_nF69RU{padding:2px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `OPyxSSwgH90qsft97wLw`,
	"rowMedia": `YTX89g_TpUTsjdszYaX6`,
	"label": `nGaU_AKcWIQTm7M9z2Ii`,
	"value": `XLhDffnrqOk1xDuJsGD5`,
	"rowField": `CjdSi1oino385ZVbJOXP`,
	"valueParagraph": `mSFfNKx97ZErWDrUFZsP`,
	"questionIcon": `Eif3jqOb860fK_nF69RU`
};
export default ___CSS_LOADER_EXPORT___;
